import ScreenLoader from "@/components/ScreenLoader";
import { lazy, Suspense } from "react";
import { Platform } from "react-native";

const MobileNavigator = lazy(() => import("./mobile/MobileNavigator"));
const WebNavigator = lazy(() => import("./web/WebNavigator"));

export default function RootNavigator() {
  return (
    <Suspense fallback={<ScreenLoader />}>
      {Platform.OS === "web" ? <WebNavigator /> : <MobileNavigator />}
    </Suspense>
  );
}
